<template>
  <form v-if="isLoaded" @submit.prevent="submitForm" novalidate>
    <div class="row">
      <div class="col-12">
        <TextEditor
            v-model="formData.description"
            @update:model-value="formData.description = $event"
            :inputStyle="{ height: '200px' }"
            label="Beschreibung"/>
      </div>
    </div>

    <div class="d-flex justify-content-center w-100 mt-3">
      <SaveButton
          :label="$t('general.button.save')"
          :loading="isSubmitting"/>
    </div>
  </form>
</template>

<script setup>
import portalCaseManagementCoachingService from '@/api/Portal/CaseManagementCoaching';
import TextEditor from '@/components/TextEditor.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { defineEmits, defineProps, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const { t }        = useI18n();
const isLoaded     = ref(false);
const isSubmitting = ref(false);
const emit         = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  coachingId: {
    type: Number,
    required: true,
  },
  protocolId: {
    type: Number,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const formData = ref({
  groupCoachingId: '',
  description: '',
});

async function submitForm() {

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +props.coachingId;

    if (props.protocolId) {
      await portalCaseManagementCoachingService.putProtocolNote(formData.value, +props.protocolId);
    } else {
      await portalCaseManagementCoachingService.postProtocolNote(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getProtocolData(protocolId) {
  try {
    const { data } = await portalCaseManagementCoachingService.getProtocol(+protocolId);

    formData.value = {
      description: data.data.description,
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (props.protocolId) {
    await getProtocolData(props.protocolId);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>